import * as Yup from "yup";

export const UserFormValidations = (otpSent: boolean) => {
  const baseSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(2, "First name must be at least 2 characters")
      .max(50, "First name must not exceed 50 characters")
      .matches(/^[A-Za-z\s-]+$/, "First name can only contain letters, spaces, and hyphens")
      .required("First name is required"),
    last_name: Yup.string()
      .min(2, "Last name must be at least 2 characters")
      .max(50, "Last name must not exceed 50 characters")
      .matches(/^[A-Za-z\s-]+$/, "Last name can only contain letters, spaces, and hyphens")
      .required("Last name is required"),
    phone_number: Yup.string()
      .transform((value) => {
        // Strip everything except digits and a single leading +. Don't force
        // a +256 prefix — Asili onboards foreign investors (e.g. UAE +971
        // for Alykhan Hudani, Jun 2026), so we accept any international
        // E.164 number. Backend validates via authentication.helpers.
        if (!value) return value;
        let cleaned = value.replace(/[^\d+]/g, "");
        // Local Uganda numbers starting with 0 still auto-prefix to +256
        // for the common case.
        if (/^0\d{9}$/.test(cleaned)) {
          cleaned = "+256" + cleaned.slice(1);
        } else if (!cleaned.startsWith("+")) {
          cleaned = "+" + cleaned;
        }
        return cleaned;
      })
      .matches(
        /^\+\d{10,15}$/,
        "Enter a valid international phone number (e.g. +256772123456 or +971503797047)"
      )
      .required("Phone number is required"),
    role: Yup.string().required("Account type is required"),
    accept_terms: Yup.boolean()
      .oneOf([true], "You must accept the terms and conditions")
      .required("You must accept the terms and conditions"),
  });

  if (otpSent) {
    return baseSchema.shape({
      otp_code: Yup.string()
        .matches(/^\d{4}$/, "OTP must be 4 digits")
        .required("OTP code is required"),
    });
  }

  return baseSchema;
};